var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-btn',{staticClass:"mr-2 book-btn",attrs:{"href":"https://www.vagaro.com/byastridbeautysalon","target":"_blank","size":"lg","type":"button"}},[_c('span',[_vm._v("Book Now")])])
}
var staticRenderFns = []

export { render, staticRenderFns }